<template>
  <MDBContainer>
    <Menu />
    <MDBRow>
      <MDBCol col="lg-3" :class="`column-order justify-content-start ${props.switchOrderMobile ? 'order-lg-1 order-2 mt-lg-0 mt-5' : null
        }`">
        <LeftColumn />
      </MDBCol>
      <MDBCol col="lg-9" :class="`${props.switchOrderMobile ? 'order-lg-2 order-1' : null}`">
        <props.content />
      </MDBCol>
    </MDBRow>
    <MDBRow class="mt-5" :class="{ 'align-items-stretch': isDashboard }">
      <MDBCol col="lg-3" :class="{ 'd-flex flex-column': isDashboard }">
        <div v-if="isDashboard" class="dashboard-teaser-heading">
          <h5>&nbsp;</h5>
        </div>
        <template v-if="!isWholesaler && !isWholesalerStaff">
          <PointBox :stretch="isDashboard" />
        </template>
      </MDBCol>
      <MDBCol col="lg-9" :class="{ 'd-flex': isDashboard }">
        <props.data />
      </MDBCol>
    </MDBRow>
    <MDBRow class="mt-3 align-items-stretch">
      <MDBCol col="lg-3" class="d-flex">
        <template v-if="!isWholesaler && !isWholesalerStaff">
          <KickbackBox />
        </template>
      </MDBCol>
      <MDBCol col="lg-9" class="d-flex">
        <div class="mt-3 w-100 nl-banner--min-height"
          v-if="route.name == 'dashboard' && showTenantBanner && showExtraBanner">
          <a href="https://aanbieding.bridgestone.nl/upload-factuur-wasbeurt/" target="_blank" class="w-100 h-100 nl-banner"></a>
        </div>
      </MDBCol>
    </MDBRow>
    <!-- new compo for apps -->
    <MDBRow class="mt-1" v-if="
      route.name == 'dashboard' &&
      showDefaultBanners &&
      defaultBanners.length > 0
    ">
      <MDBCol col="12" :md="12 / defaultBanners.length" v-for="(banner, index) in defaultBanners" :key="index">
        <img :src="banner.path" :alt="banner.path" />
      </MDBCol>
    </MDBRow>

    <Footer />
  </MDBContainer>


</template>

<script setup>
import { MDBCol, MDBRow, MDBContainer } from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Menu from "@/components/Layout/Menu.vue";
import Footer from "@/components/Layout/Footer.vue";
import LeftColumn from "@/components/Layout/LeftColumn.vue";
import KickbackBox from "@/components/Dashboard/KickbackBox.vue";
import PointBox from "@/components/Dashboard/PointBox.vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { defineProps, ref, watch, computed, onMounted } from "vue";
import TokenService from "@/services/storage.service";

const { tenantConfig } = useTenantConfig();
const store = useStore();
const showDefaultBanners = ref(false);

const route = useRoute();
const isDashboard = computed(() => route.name == "dashboard");
const props = defineProps({
  content: Object,
  switchOrderMobile: Boolean,
  data: Object,
});

const user = computed(() => store.getters.getMe);
const defaultBanners = computed(() => store.getters.getDefaultBanners);
const meIsPending = computed(() => store.getters.getIsMePending);
const permissions = computed(() => store.getters.getPermissions);
const showExtraBanner = computed(() => {
  return permissions.value && TokenService.showElement("kickBackFeeBox.see");
});
const showTenantBanner = computed(
  () => tenantConfig.value?.showNlCarwashBanner ?? false
);
const isWholesalerStaff = ref(false);
const isWholesaler = ref(false);
watch(user, async (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "wholesaler")) {
    isWholesaler.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "wholesalerStaff")) {
    isWholesalerStaff.value = true;
  }
});


onMounted(async () => {
  if (
    user.value &&
    user.value.roles &&
    user.value.roles.find((item) => item.name == "dealer")
  ) {
    if (!meIsPending.value) {
      await store.dispatch("me");
    }
  }

  showDefaultBanners.value = TokenService.showElement(
    "mainPage.defaultBanners"
  );

  if (showDefaultBanners.value) {
    await store.dispatch("fetchDefaultBanners");
  }
});

</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/bottom_banner.scss";
@import "@/styles/dashboard_teaser.scss";

.bg-modal {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
</style>
